// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wo_chien: PokeData = {
  "id": 1001,
  "name": "wo-chien",
  "height": 15,
  "weight": 742,
  "base_experience": 285,
  "types": [
    PokeType.DARK,
    PokeType.GRASS
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "spite",
    "giga-drain",
    "mean-look",
    "ingrain",
    "knock-off",
    "tickle",
    "payback",
    "dark-pulse",
    "leaf-storm",
    "power-whip",
    "foul-play",
    "grassy-terrain",
    "ruination"
  ],
  "moves": [
    "poison-powder",
    "stun-spore",
    "dark-pulse",
    "power-whip",
    "grassy-terrain",
    "overgrowth",
    "flower-rush",
    "razor-leaf",
    "night-daze",
    "night-slash",
    "bite",
    "crunch",
    "snarl"
  ],
  "evolution_chain": {
    "id": 529,
    "item": null,
    "species": [
      {
        "name": "wo-chien",
        "order": 996,
        "types": [
          PokeType.DARK,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 152,
    "speed": 105,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 6,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
